import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { CircuitTraces } from './CircuitTraces';
import { SignalWaves } from './SignalWaves';
import { BlueprintGrid } from './BlueprintGrid';
export function Footer() {
  return <footer className="relative bg-navy grain overflow-hidden text-white py-16 px-6" data-id="element-75" data-mp="32lrlpcbxyvjg">
      {/* Motif layers */}
      <div className="absolute inset-0 text-white/[0.15] mix-blend-soft-light" data-id="element-76" data-mp="36n3grxdl48z1">
        <BlueprintGrid data-id="element-77" data-mp="3ucxpc2qvfbdh" />
      </div>
      <div className="absolute inset-0 text-white/[0.12]" data-id="element-78" data-mp="38h7nghhhuo4">
        <CircuitTraces data-id="element-79" data-mp="37xv6falryhh" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-navy/20 via-transparent to-navy/30" data-id="element-80" data-mp="3lelzi2xtwhm3" />

      <div className="relative max-w-7xl mx-auto z-10 space-y-10" data-id="element-81" data-mp="3qd6rxg6u9wzz">
        {/* Row 1: Brand */}
        <div data-id="element-82" data-mp="29zgj5w4rykk0">
          <div className="flex items-center gap-5 mb-3" data-id="element-83" data-mp="29yxe3g083qne">
            <img src="https://cdn.magicpatterns.com/uploads/pCtzMmZ2ci5LGu7D7o9MNa/GTH_Logo_(3).png" alt="Growth That Holds mark" className="h-14 w-auto brightness-0 invert opacity-90" data-id="element-84" data-mp="2a1jl9ej7c453" />
            <div className="w-px h-10 bg-seaglass/40" data-id="element-85" data-mp="3gb8wb37h9evl" />
            <div data-id="element-86" data-mp="3gcjw6rxsy2hf">
              <h3 className="text-2xl font-serif font-semibold text-white tracking-[0.25em] uppercase leading-tight" data-id="element-87" data-mp="3v7q2lg0t83ba">
                Growth
              </h3>
              <p className="text-[0.85rem] font-serif font-medium text-white/80 tracking-[0.43em] uppercase leading-tight" data-id="element-88" data-mp="3q7bw42eux1fd">
                That Holds
              </p>
            </div>
          </div>
          <p className="text-sm text-white/60" data-id="element-89" data-mp="33nmi62lvjkp">
            Revenue Journey Redesign for companies where too much revenue is
            getting stuck, lost, or missed between first interest and full
            customer lifetime value.
          </p>
        </div>

        {/* Row 2: Nav links — horizontal strip */}
        <div className="border-t border-white/10 pt-10" data-id="element-90" data-mp="qr5i6cozr1sy">
          <p className="eyebrow text-white/40 mb-5" data-id="element-91" data-mp="msy4jqptqglz">Navigate</p>
          <ul className="flex flex-wrap gap-x-8 gap-y-3" data-id="element-92" data-mp="tvd13wd6udh9">
            {[{
            label: "What's Wrong",
            to: '/whats-wrong'
          }, {
            label: 'How We Fix It',
            to: '/how-we-fix-it'
          }, {
            label: 'Where AI Fits',
            to: '/where-ai-fits'
          }, {
            label: 'About John',
            to: '/about-john'
          }, {
            label: 'Book an Honest Conversation',
            to: '/honest-conversation'
          }].map(link => <li key={link.to} data-id="element-93" data-mp="1mhpaiqioou2r">
                <Link to={link.to} className="text-sm text-white/70 hover:text-white transition-colors duration-300" data-id="element-94" data-mp="1rjeqmkkrjxxp">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>

        {/* Row 3: Contact + copyright */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-95" data-mp="2afx2n01a495z">
          <a href="mailto:john@growththatholds.com" className="flex items-center space-x-2 text-sm text-white/70 hover:text-white transition-colors duration-300 group" data-id="element-96" data-mp="25n3yad9q32uf">
            <Mail className="w-4 h-4 group-hover:text-seaglass transition-colors duration-300" data-id="element-97" data-mp="1wlm8u4afdot2" />
            <span data-id="element-98" data-mp="2tbvjgkowakxp">john@growththatholds.com</span>
          </a>
          <p className="text-sm text-white/40" data-id="element-99" data-mp="2pdfo9tinu697">
            &copy; {new Date().getFullYear()} Growth That Holds. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}